module.exports = __webpack_public_path__ + "img/icon-speedometer.93805c39.svg";